import Logo from '@locus-labs/mol-desktop-logo'
import { rgba } from 'polished'
import React from 'react'
import styled, { withTheme } from 'styled-components'

import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { Input2 } from '../../../../../src/ui/inputs/Input2.jsx'
import ToolTipComponent from '../../../../../src/ui/tooltips/ToolTipComponent.jsx'

import { FlightTypeToggle } from './FlightTypeToggle.jsx'

const WidgetWrapper = styled.div`
  width: 100%;
  padding: ${({ hasLogoUrl, theme }) =>
  hasLogoUrl && theme.header.hasLogo
    ? theme.header.paddingWithLogo
    : theme.header.padding};
`

const FlightTypeToggleStyled = styled(FlightTypeToggle)`
  margin-bottom: 12px;
`

const BackButton = styled.button`&&&{
  display: inline-flex;
  align-items: center;
  margin-bottom: 15px;
  margin-top: ${({ logoUrl }) => logoUrl ? '16px' : '0px'};
  user-select: none;
  color: ${({ theme }) => theme.colors.widgetIconFill};
  ${({ theme }) => theme.fontSize('12px')};
  cursor: pointer;
  position: relative;
  background-color: transparent;
  border: none;
}
`

const NavBar = styled.div`
  width: 100%;
  height: 44px;
  background: ${({ theme }) => rgba(theme.colors.widgetText, 0.1)};
  border-radius: ${({ theme })=> theme.standardRadius};
  display: flex;
  padding: 8px;
  align-items: center;

  button {
    width: 32px;
    outline: none;
    border: none;
    background: transparent;
    padding: 0;
    position: relative;
  }
`

const NavBarComponent = styled.div`
  flex: 0 1 auto;
`

const Input2Styled = styled(Input2)`
  flex: 1 1 auto;
  padding: 0;
`

const HeaderView = ({
  placeholder,
  currentFlightType,
  searchTerm,
  onFlightTypeSwitched,
  onSearchTermChange,
  theme,
  logoUrl,
  logoLinkUrl,
  onBackButtonClicked,
  clientName,
  T
}) => {
  return (
    <WidgetWrapper hasLogoUrl={typeof logoUrl !== 'undefined'}>
      {logoUrl && theme.header.hasLogo && (
        <Logo
          logoHeight={theme.logo.height}
          alt={clientName}
          url={logoUrl}
          width="auto"
          position={theme.logo.centered ? 'center' : 'left'}
          padding={theme.logo.padding}
        />
      )}
      <BackButton logoUrl={logoUrl} tabIndex="0" onClick={() => onBackButtonClicked()}>
        <ColoredIcon
          className="icon"
          width={24}
          height={24}
          id="arrow-left"
          fillColor={theme.colors.widgetIconFill}
        />
        <u>{T('flightDetails:Home')}</u>
      </BackButton>

      <FlightTypeToggleStyled
        currentFlightType={currentFlightType}
        onFlightTypeClicked={onFlightTypeSwitched}
        T={T}
      />

      <NavBar>
        <NavBarComponent>
          <ToolTipComponent
            tooltipText={T('flightDetails:Search')}
            arrowPosition="top"
          >
            <ColoredIcon
              id="search"
              width={32}
              height={32}
              fillColor={theme.colors.widgetText}
            />
          </ToolTipComponent>
        </NavBarComponent>

        <Input2Styled
          color={theme.colors.widgetText}
          placeholder={placeholder}
          value={searchTerm}
          onChange={onSearchTermChange}
          title={placeholder}
          T={T}
        />
      </NavBar>
    </WidgetWrapper>
  )
}

export default withTheme(HeaderView)
